var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "mt-2", attrs: { align: "center", justify: "center" } },
    [
      _c("span", { staticClass: "grey--text" }, [_vm._v("Items per page")]),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: { offsetY: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        staticClass: "ml-2",
                        attrs: { dark: "", text: "", color: "primary" },
                      },
                      on
                    ),
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.itemsPerPage) + "\n        "
                      ),
                      _c("v-icon", [_vm._v("mdi-chevron-down")]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            _vm._l(_vm.itemsPerPageArray, function (number, index) {
              return _c(
                "v-list-item",
                {
                  key: index,
                  on: {
                    click: function ($event) {
                      return _vm.updateItemsPerPage(number)
                    },
                  },
                },
                [_c("v-list-item-title", [_vm._v(_vm._s(number))])],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _c("span", { staticClass: "mr-4 grey--text" }, [
        _vm._v(
          "\n    Page " +
            _vm._s(_vm.page) +
            " of " +
            _vm._s(_vm.numberOfPages) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mr-1",
          attrs: { fab: "", dark: "", color: "blue darken-3" },
          on: { click: _vm.formerPage },
        },
        [_c("v-icon", [_vm._v("mdi-chevron-left")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "ml-1",
          attrs: { fab: "", dark: "", color: "blue darken-3" },
          on: { click: _vm.nextPage },
        },
        [_c("v-icon", [_vm._v("mdi-chevron-right")])],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }